export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <div className="rounded-2xl bg-background-100 border border-background-200/50 p-8 md:p-12">
            <div className="text-center mb-8">
              <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
                关于我们
              </h2>
              <p className="text-sm md:text-base text-foreground-600">
                51吃瓜黑料 — 让每一次吃瓜都有料可查
              </p>
            </div>

            <div className="prose prose-sm max-w-none">
              <div className="space-y-5 text-sm md:text-base text-foreground-700 leading-relaxed">
                <p>
                  <strong className="text-foreground-900">51吃瓜黑料</strong>成立于2024年，是国内领先的娱乐八卦与黑料爆料视频聚合平台。我们致力于为广大吃瓜群众提供最新、最全、最真实的<strong className="text-foreground-900">51吃瓜黑料视频</strong>在线观看服务。
                </p>
                <p>
                  平台汇聚了来自全网的海量<strong className="text-foreground-900">吃瓜视频</strong>和<strong className="text-foreground-900">黑料爆料视频</strong>，内容覆盖明星艺人、网络红人、综艺节目、商业圈层等多个领域。无论是恋情实锤、网红翻车还是行业黑幕，51吃瓜黑料都为你实时追踪、深度解析。
                </p>
                <p>
                  我们坚持"真实、及时、全面"的内容理念，建立了严格的多源验证机制。每一段<strong className="text-foreground-900">51吃瓜视频</strong>上线前均经过专业编辑团队审核，确保信息准确可靠。同时，平台采用先进的视频播放技术，保证<strong className="text-foreground-900">黑料视频在线</strong>观看流畅无卡顿，支持手机和电脑双端访问。
                </p>
                <p>
                  从每日更新的热门话题，到独家深度专题报道；从实时热度排行榜，到瓜友社区互动——51吃瓜黑料正在打造中国最活跃的娱乐八卦内容生态。吃瓜不迷路，黑料不错过，51吃瓜黑料始终与你一起，见证每一个值得关注的爆料时刻。
                </p>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-background-200/50">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
                <div>
                  <div className="text-2xl font-heading text-primary-500">2年+</div>
                  <div className="text-xs text-foreground-500 mt-1">持续运营</div>
                </div>
                <div>
                  <div className="text-2xl font-heading text-primary-500">10万+</div>
                  <div className="text-xs text-foreground-500 mt-1">视频内容</div>
                </div>
                <div>
                  <div className="text-2xl font-heading text-primary-500">50万+</div>
                  <div className="text-xs text-foreground-500 mt-1">日均访问</div>
                </div>
                <div>
                  <div className="text-2xl font-heading text-primary-500">99.9%</div>
                  <div className="text-xs text-foreground-500 mt-1">服务可用率</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}